module.exports = __webpack_public_path__ + "static/system-design-1ea2dc05d7baf6c0525babda46772892.png";